import { isAuthenticated } from "@store/action/auth"

export function bearerToken(token) {
  return `Bearer ${token}`
}

export function authorizationHeader() {
  const { token } = isAuthenticated();
  if (!token) return null;

  return bearerToken(token);
}
